import React, { useState, useEffect, useCallback } from "react";
import { stratificationService } from "../../services/stratification.services";
import { RiskAtcGroupsSection } from "./RiskAtcGroupsSection";
import { RiskDiagnosesSection } from "./RiskDiagnosesSection";
import { RiskLabParametersSection } from "./RiskLabParametersSection";
import { KeywordsSection } from "./KeywordsSection";
import { PopUp } from "../PopUps/PopUp";
import "../../assets/css/stratification.css";

export const StratificationSettings = () => {
  const [riskAtcGroups, setRiskAtcGroups] = useState([]);
  const [riskDiagnoses, setRiskDiagnoses] = useState([]);
  const [riskLabParameters, setRiskLabParameters] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false });

  const loadData = useCallback(async (isInitial = false) => {
    try {
      if (isInitial) setLoading(true);
      const [atcRes, diagRes, labRes, kwRes] = await Promise.all([
        stratificationService.getRiskAtcGroups({ limit: 1000 }),
        stratificationService.getRiskDiagnoses({ limit: 1000 }),
        stratificationService.getRiskLabParameters({ limit: 1000 }),
        stratificationService.getKeywords({ limit: 1000 }),
      ]);
      setRiskAtcGroups(atcRes.results || []);
      setRiskDiagnoses(diagRes.results || []);
      setRiskLabParameters(labRes.results || []);
      setKeywords(kwRes.results || []);
    } catch (err) {
      console.error("Error loading stratification data:", err);
      setError({
        error: true,
        message: "Chyba při načítání dat stratifikace",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData(true);
  }, [loadData]);

  const togglePopup = () => {
    setError({ error: false });
  };

  if (loading) {
    return (
      <div className="stratification-container">
        <div className="stratification-content">
          <div className="stratification-loading">
            Načítání nastavení stratifikace...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="stratification-container">
      <div className="stratification-content">
        {error.error && <PopUp toggle={togglePopup} message={error.message} />}

        <h2 className="stratification-title">Nastavení stratifikace</h2>

        <RiskAtcGroupsSection items={riskAtcGroups} onRefresh={loadData} />
        <RiskDiagnosesSection items={riskDiagnoses} onRefresh={loadData} />
        <RiskLabParametersSection
          items={riskLabParameters}
          onRefresh={loadData}
        />
        <KeywordsSection items={keywords} onRefresh={loadData} />
      </div>
    </div>
  );
};
